<template>
<div style='z-index:6'>
  <div v-if='expandedState' class='modalClickLayer' @click='cancelLayerClicked'></div>
  <div class='filterBox' @click='expandedState = !expandedState'>
    <button class='summary'>
      {{ summaryOfSelection }} <span style='flex-grow:1'></span><span class='downArrow'>&#8250;</span>
    </button>
    <div v-if='expandedState' class='filterItemList'>
      <!-- <transition name='expand'> -->
        <template v-if='expandedState'>
          <div :class='{filterItem: true, selected: copyOfList[index].selected, heading: copyOfList[index].isHeading}' v-for='(item, index) in copyOfList' :key='JSON.stringify(item) + index' @click='toggleSelectionIndex(index, $event)'>
            <slot>
              <template v-if='copyOfList[index].isHeading'>
                <partial-checkbox :label='copyOfList[index].value' :value='copyOfList[index].headingStateObject.state' @change='handleHeadingChange' :headingStateObject='copyOfList[index].headingStateObject'/>
              </template>
              <template v-else>
                {{ copyOfList[index].value }}
                <template v-if="copyOfList[index].selected">
                  <span style='font-size: 0.8em'>(selected)</span>
                </template>
              </template>
            </slot>
          </div>
        </template>
      <!-- </transition> -->
      <hr/>
      <button style='display: inline; font-size:0.8em' @click='selectAll' id='selectAllButton'>SELECT ALL</button>
      <button v-if='!disableClearButton' style='display: inline; font-size:0.8em' @click='clearSelection' id='clearButton'>CLEAR SELECTION</button>
    </div>
  </div>
</div>
</template>

<script>
import partialCheckbox from '@/components/partialCheckbox'
export default {
  name: 'filterBox',
  components: { partialCheckbox },
  props: {
    value: null,
    list: {
      type: Array,
      required: true
    },
    multiple: Boolean,
    canEnterNewValue: Boolean,
    which: String,
    disableClearButton: Boolean,
    singularText: String,
    pluralText: String,
    selectAllOnMount: {
      type: Boolean,
      default: true
    },
    expandOnMount: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expandedState: this.expandOnMount,
      selectedIndexes: {},
      copyOfList: [],
      newItemTextValue: '',
      headingStates: []
    }
  },
  watch: {
    headingStates: function () {
      this.recalcHeadingStates()
    },
    copyOfList: function () {
      this.recalcHeadingStates()
    }
  },
  mounted: function () {
    // Also copy the input list
    // Should also watch for changes to the list, as we'll need to be careful when handling them
    if (this.list) {
      // this.copyOfList = JSON.parse(JSON.stringify(this.list))
      var headingStateObject // Once we hit a heading, we'll be in that heading section until get to a new one
      for (var j in this.list) {
        if (this.list[j][0].valueOf() === '*'.valueOf()) {
          // Treat this as a heading
          headingStateObject = {
            state: true,
            countSelected: 0,
            childrenIndices: []
          }
          // this.list[j].headingStateObject = headingStateObject
          this.copyOfList.push({'isHeading': true, 'selected': false, 'value': JSON.parse(JSON.stringify(this.list[j].substr(1))), headingStateObject: headingStateObject})
          this.headingStates.push(headingStateObject)
        } else {
          this.copyOfList.push({'selected': false, 'value': JSON.parse(JSON.stringify(this.list[j])), headingStateObject: headingStateObject})
          if (headingStateObject) {
            headingStateObject.childrenIndices.push(j)
          }
        }
      }
    }
    // Take the input "value" and convert it into the format that this component uses internally for keeping track of the selection
    // Might run into trouble here if the list, and the selected items are objects rather than just strings... will have to see
    var index
    if (this.value && (this.value.length)) {
      for (var i in this.value) {
        // Value is an array of selected values, longer than 1
        index = this.list.indexOf(this.value[i])
        if (index >= 0) {
          this.toggleSelectionIndex(index)
        }
      }
    } else {
      // console.log('No initial value set')
      // Start by setting all items to be toggled on by default
      this.copyOfList.forEach((listItem, index) => {
        if (!listItem.isHeading) {
          this.toggleSelectionIndex(index)
          if (!this.selectAllOnMount) {
            // Quick and simple way, toggle back off. Am using toggle to initialise as well as toggle, so easier this way
            this.toggleSelectionIndex(index)
          }
        }
      })
    }
  },
  methods: {
    cancelLayerClicked () {
      this.expandedState = false
    },
    clearSelection: function (e) {
      // console.log(e)
      e.stopPropagation()
      for (var i in this.copyOfList) {
        if (this.copyOfList[i].selected) {
          this.copyOfList[i].selected = false
        }
      }
      this.recalcHeadingStates()
      this.$emit('input', this.currentValue)
    },
    selectAll (e) {
      e.stopPropagation()
      for (var i in this.copyOfList) {
        this.copyOfList[i].selected = true
      }
      this.recalcHeadingStates()
      this.$emit('input', this.currentValue)
    },
    toggleSelectionIndex: function (index, event) {
      if (this.copyOfList[index].isHeading) {
        return // Skip because this is a heading
        // Handle this a bit more fancy soon, or not do it here
        // Don't stop event propagation here
      }
      if (event) {
        event.stopPropagation()
      }
      if (!this.multiple) {
        // console.log('Should clear existing options now')
        for (var i in this.copyOfList) {
          if (this.copyOfList[i].selected) {
            this.copyOfList[i].selected = false
          }
        }
      }
      // console.log(index)
      // this.selectedIndexes[index + 'i'] = !this.selectedIndexes[index + 'i']
      this.copyOfList[index].selected = !this.copyOfList[index].selected
      // console.log(this.selectedIndexes)
      // console.log(this.copyOfList)
      this.$emit('input', this.currentValue)
      this.recalcHeadingStates()
    },
    recalcHeadingStates: function () {
      // Recalculate the heading states based on the children items
      this.headingStates.forEach(headingStateObject => {
        var newStateValue = true
        var countChildrenSelected = 0
        headingStateObject.childrenIndices.forEach(index => {
          newStateValue = newStateValue && this.copyOfList[index].selected
          if (this.copyOfList[index].selected) {
            countChildrenSelected++
          }
        })
        headingStateObject.countSelected = countChildrenSelected
        headingStateObject.state = newStateValue
      })
    },
    handleHeadingChange: function (obj) {
      console.log({obj})
      var newStateValue = obj.state
      var headingStateObject = obj.headingStateObject
      headingStateObject.childrenIndices.forEach(index => {
        this.copyOfList[+index].selected = newStateValue
      })
      this.$emit('input', this.currentValue)
      this.recalcHeadingStates()
    }
  },
  computed: {
    summaryOfSelection: function () {
      if (this.currentValue) {
        if (this.which.valueOf() === 'stockistType') {
          if (this.currentValue.length === 0) {
            return 'No stockist types selected'
          } else if (this.currentValue.length === 1) {
            return 'Showing ' + this.currentValue[0] + ' stockists'
          } else {
            return 'Showing ' + this.currentValue.join(' and ') + ' stockists'
          }
        } else {
          if (this.currentValue.length === 1) {
            return this.currentValue.length + ' ' + this.singularText + ' Selected'
          }
          return this.currentValue.length + ' ' + this.pluralText + ' Selected'
        }
      } else {
        return ''
      }
    },
    currentValue: function () {
      var selectedArray = []
      if (!this.multiple) {
        for (var i in this.copyOfList) {
          if (this.copyOfList[i].selected) {
            return this.copyOfList[i].value
          }
        }
        return selectedArray
      } else {
        for (var x in this.copyOfList) {
          if (this.copyOfList[x].selected) {
            selectedArray.push(this.copyOfList[x].value)
          }
        }
        return selectedArray
      }
    }
  }
}
</script>

<style scoped>
.filterBox {
  background: rgb(247, 247, 247);
  /* padding: 0.2em; */
  /* width: 218px; */
  box-sizing: border-box;
  margin: 1rem;
  z-index: 20;
  position: relative;
  border-radius: 2px;
}
.summary {
  font-size: 1em;
  text-transform: uppercase;
  margin: 0;
}
/* .summary {
  padding: 0.7em;
  padding-top: 0.9em;
  position: relative;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: row
} */
.downArrow {
  font-size: 1.3em;
  margin-left: 1em;
  transform: rotate(90deg);
  display: inline-block;
}
.modalClickLayer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 8;
}
.filterItemList button {
  min-width: 80%;
  margin: 0.2em auto
}
/* #clearButton {
  z-index: 20;
  margin-top: 1.5em;
  position: relative;
  background: white;
  color: rgba(0,0,0,0.7);
  box-shadow: none
} */
.filterItemList {
  box-shadow: 2px 2px 12px rgba(0,0,0,0.7);
  position: absolute;
  background: #fffff5;
  /* width: 238px; */
  box-sizing: border-box;
  padding: 0.2em;
  /* margin-left: -0.2em; */
  border-top: 0;
  border-radius: 2px;
  /* border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em; */
  z-index: 21;
}
.filterItem {
  /*background: rgb(219, 219, 219);*/
  padding: 0.8em 0.5em;
  position: relative;
  z-index: 22;
  text-align: left;
  border-left: 0.5em #fffff5 solid;
  font-size: 1.1em;
}
.filterItem:hover {
  cursor: pointer;
}
.filterItem.selected {
  background: hsl(78, 56%, 90%);
  /* color: white; */
  border-color: #b0d25e;
}
.heading {
  font-weight: bold;
}
.heading:hover {
  cursor: default;
}

.expand-enter-active {
  animation: coming 0.2s;
  opacity: 0
}
.expand-leave-active {
  animation: going 0.2s;
}
@keyframes coming {
  from {
    transform: translateY(-10px);
    opacity: 0.8;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes going {
  from {
    transform: translateY(0px);
    opacity: 1;
  }
  to {
    transform: translateY(-10px);
    opacity: 0.2;
  }
}
@media screen and (max-width: 700px) {
  .filterBox {
    /* margin: 0.5em; */
  }
}
hr {
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/filterBox.vue